import { SAVE_FIELDS } from './checklistSave';

export const RESPONSE_FIELDS = [
  'score',
  'score_set',
  'has_been_scored',
  'answer_text',
  'answer_numeric',
  'answer_date',
  'answer_bool',
  'selected_options',
];

/** #Fase1-10 — Conserva una copia para deshacer N/A antes de que salga a la red. */
export function captureBeforeNA(item, dirty) {
  return { item: { ...item }, dirty: { ...dirty } };
}

export function undoPendingNA(item, dirty, backup) {
  const next = { ...item };
  const nextDirty = { ...dirty };
  [...RESPONSE_FIELDS, 'not_applicable', 'na_reason'].forEach((field) => {
    next[field] = backup.item[field];
    delete nextDirty[field];
    if (backup.dirty[field] != null) nextDirty[field] = backup.dirty[field];
  });
  return { item: next, dirty: nextDirty };
}

export function serverItems(evaluation) {
  const result = {};
  (evaluation.sections || []).forEach((section) =>
    (section.criteria || []).forEach((criterion) => {
      const key = criterion.criterion_id ?? criterion.question_id;
      result[key] = { ...criterion, notes: criterion.notes ?? criterion.response_notes };
    })
  );
  (evaluation.items || []).forEach((item) => {
    const key = item.criterio_id ?? item.question_id;
    result[key] = { ...result[key], ...item, has_been_scored: item.score_set === true };
  });
  return result;
}

/** Respeta ediciones en curso, incluyendo las que nacieron después de iniciar el GET. */
export function reconcileItems(local, incoming, dirty, editsSinceRequest = {}) {
  const next = { ...local };
  const changedNA = [];
  Object.entries(incoming).forEach(([key, server]) => {
    const pending = { ...dirty[key], ...editsSinceRequest[key] };
    const current = local[key] || {};
    const hasResponse = RESPONSE_FIELDS.some((field) => pending[field]);
    const protectNA = pending.not_applicable || hasResponse;
    const merged = { ...current, ...server };
    SAVE_FIELDS.forEach((field) => {
      if (pending[field]) merged[field] = current[field];
    });
    if (protectNA) {
      merged.not_applicable = current.not_applicable;
      merged.na_reason = current.na_reason;
      RESPONSE_FIELDS.forEach((field) => {
        merged[field] = current[field];
      });
    }
    if (!protectNA && !!current.not_applicable !== !!server.not_applicable) changedNA.push(key);
    next[key] = merged;
  });
  return { items: next, changedNA };
}
